import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
  Button,
  Modal,
  message,
  Input,
  Select,
} from "antd";
import R2Footer from "../../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./style.scss";
import TableSection from "./childrens/tableList";
import EditModal from "./childrens/editModal";
import EmployeeService from "../../../services/EmployeeService"; 
import DetailsPage from "./childrens/detailsPage";
import AddEditEmployee from "./childrens/AddEditEmployee";
import { SearchOutlined } from "@ant-design/icons";

const { Content } = Layout;

const AllEmployee = (props) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [userList, setUserList] = useState([]);
  const [viewPage, setViewPage] = useState("adds");
  const [selectedRow, setSelectedRow] = useState({});
  const [editId, setEditId] = useState('');
  const [loading, setLoading] = useState(true);
  const [defaultPage, setDefaultPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [searchType, setSearchType] = useState('');
  const [dataList, setDataList] = useState([]);


  const getAllUsers = (text="", type="") => {
    setLoading(true);
    const restaurant_id = props.adminRestaurant;
    EmployeeService.getAllEmploye(defaultPage, text, type).then((resp)=>{
      setUserList(resp);
      setLoading(false);
    });
  };
  const getCustomizationList = async() => {
    const res = await EmployeeService.getEmployeType(props.adminRestaurant);
    setDataList(res);
}

  useEffect(()=>{
    getAllUsers("", "");
    setSearchText('');
    setSearchType('');
    setDefaultPage(1);
    getCustomizationList();
  },[props.adminRestaurant]);
  
  useEffect(()=>{
    getAllUsers(searchText, searchType);
  },[defaultPage]);

  const onSearchText = (e) => {
    setSearchText(e.target.value);
    setDefaultPage(1);
    getAllUsers(e.target.value, searchType);
  };
  const onSearchType = (e) => {
    getAllUsers(searchText, e);
    setSearchType(e);
  };
  const onDelete = (data) => {
    setShowDeleteConfirm(data);
  };
  const onEditClick = (record) => {
    // setShowEdit(true)
    setViewPage('add');
    setEditId(record);
  };
  const onInfoClick = (data) => {
    // setShowEdit('details');
    setViewPage('details');
    setSelectedRow(data);
  };
  const deleteApiCall = () => {
    EmployeeService.deleteEmploye(showDeleteConfirm.id).then((res)=>{
      if(res){
        setShowDeleteConfirm(false);
        getAllUsers();
        message.success("Deleted successfully");
      }
    })
  }
  const onReInvite = (data) => {
    const reqData = {
      name: data.name,
      phone_number: data.phone_number,
      email: data.email,
      employee_type_id: data.restaurant_roles[0].employee_type_id,
      employee_code: data.restaurant_roles[0].employee_code,
      restaurant_id: props.adminRestaurant
    };
    EmployeeService.sendInvite(reqData).then((res)=>{
      if(res){
        message.success("Invite send successfully");
      }
    }).catch((e)=>{
      message.error(e?.response?.data?.msg);
    });
  };

  if(viewPage === 'add') {
    return <AddEditEmployee setViewPage={setViewPage} record={editId} setEditId={setEditId} getAllUsers={getAllUsers} />
  }
  return (
    <Layout className="u-page-layout">
      <Content className="all__employe_ui page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          {viewPage === 'details' && <> 
            <DetailsPage 
              setViewPage={setViewPage} 
              selectedRow={selectedRow} 
              onReInvite={onReInvite} 
              onEditDetails={onEditClick}
            />
          </>
          ||
          <>
            <PageHeader 
            className="page-header-business"
              title="All Employee"
              extra={[
                <div style={{ display: "flex" }}>
                <Input
                  prefix={<SearchOutlined style={{ color: "#262626" }} />}
                  placeholder="Search Employee"
                  onChange={onSearchText}
                />
                <Select
                  placeholder="Filter"
                  style={{ width: 140 }}
                  onChange={onSearchType}
                  allowClear
                  options={dataList?.map((item)=> ({ label: item.name, value: item.id }))}
                />
              </div>,
                <Button type="primary" onClick={()=> setViewPage('add')}>Add New Employee</Button>
              ]} 
            style={{ background: "#f0f2f5" }} 
            />
            <div>
              <TableSection 
                onDelete={onDelete} 
                onEditClick={onEditClick} 
                userList={userList || []}  
                onInfoClick={onInfoClick} 
                loading={loading}
                setDefaultPage={setDefaultPage}
                defaultPage={defaultPage}
              />
            </div>
            <Modal visible={showDeleteConfirm} footer={null} onCancel={()=>setShowDeleteConfirm(false)} className="member_deleteconfirm">
              <div className="confirm_wrap">
                <h3 className="title">Are you sure?</h3>
                <div className="content">Do you really want to delete these record? This process can’t be undone </div>
                <div className="btn_section">
                      <Button type="default" className='field_save_btn' style={{ width:"200px", height: "35px", marginRight: "10px" }} onClick={()=>setShowDeleteConfirm(false)}>Cancel</Button>
                      <Button type="primary" className='field_save_btn' style={{ width:"200px", height: "35px" }} onClick={()=> deleteApiCall()}>Delete</Button>
                </div>
              </div>
            </Modal>
            <EditModal 
              showEdit={showEdit}
              setShowEdit={setShowEdit}
            />
          </>}
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(AllEmployee));
